<template>
  <div class="allContent">
    <div class="userInfo">
      <div class="userImg">
        <img :src="state.userAvatar" alt="" />
      </div>
      <div class="userText">
        <div class="userName">{{ state.userName }}</div>
        <div class="userTime" v-if="!state.monthcardFlag">
          未开通·开通尊享特权福利
        </div>
        <div class="userTime" v-else>到期时间：{{ state.time }}</div>
      </div>
      <div class="userHistoty">
        <span @click="goGetRecord()">
          领取记录
        </span>
      </div>
    </div>

    <!-- <div class="award_info" v-if="state.monthcardFlag">
      <h3>月卡福利（2选1）</h3>
      <ul>
        <li
          :class="[state.awardNum == 'coupon' ? 'active' : '']"
          @click="selectAward('coupon')"
        >
          <div>
            <p>¥<span>6</span></p>
            <p>无门槛券</p>
          </div>
        </li>
        <li
          :class="[state.awardNum == 'givemoney' ? 'active' : '']"
          @click="selectAward('givemoney')"
        >
          <div>
            <p>X<span>5</span></p>
            <p>5赠送余额</p>
          </div>
        </li>
      </ul>
      <p @click="getAward">立即领取</p>
    </div> -->

    <div class="cardInfo">
      <div class="buyCard">
        <div class="cardRule" @click="$router.push('/sdkMonthDesc')">
          <img
            src="../../../assets/yz/monthIcon/yz_newMonth_slice.png"
            alt=""
          />
          <span> 折扣神器省钱月卡购买及使用规则 </span>
          <img src="../../../assets/yz/monthIcon/yz_newMonth_go.png" alt="" />
        </div>
        <div class="cardDetails">
          <li
            @click="selectCard(item)"
            v-for="(item, index) in state.monthCardInfo"
            :class="[state.activeNum === item.id ? 'active' : '']"
          >
            <p>{{ item.name }}</p>
            <p v-if="item.jiazhi">{{ item.jiazhi }}元</p>
            <p v-else class="emptyMoney"></p>
            <p>{{ item.amount }}<span>元</span></p>
            <div v-if="item.title">{{ item.title }}</div>
          </li>
        </div>
        <div class="yuqInfo">
          <h3>
            最高共计可得
            <span>{{ state.maxAward }}元</span>
            超值{{ state.maxPercent }}%
          </h3>
          <div class="yuqInfo_content">
            <div class="yuqInfo_left">
              <h4>开通立返</h4>
              <div>
                <p>
                  ¥<span>{{ state.coupon_money }}</span>
                </p>
                <p>无门槛券</p>
              </div>
              <p>立返{{ state.coupon_money }}元优惠券</p>
            </div>
            <div class="yuqInfo_right">
              <h4>
                每日福利2选1 <span> x{{ state.dayNum }}天 </span>
              </h4>
              <div>
                <div class="right_coupon">
                  <div>
                    <p>¥<span>6</span></p>
                    <p>无门槛券</p>
                  </div>
                  <p>最高共计{{ state.maxGivecoupon }}元</p>
                </div>
                <p>或</p>
                <div class="right_givemoney">
                  <div>
                    <p>X<span>5</span></p>
                    <p>5赠送余额</p>
                  </div>
                  <p>最高共计{{ state.maxGiveMoney }}元</p>
                </div>
              </div>
            </div>
          </div>
          <li>
            ·开通立返<span>{{ state.coupon_money }}元</span>无门槛优惠券
          </li>
          <li>·优惠券券在0.1折/0.05折游戏内将<span>膨胀百倍</span></li>
          <li>·6元券开通后立即发放1张，之后每日00:10自动发放</li>
        </div>

        <div class="goBuyCard">
          <p @click="openCard" v-if="!state.monthcardFlag">
            立即开通 ({{ state.amount }}元)
          </p>
          <p v-else @click="openCard">立即续费 ({{ state.amount }}元)</p>
        </div>
      </div>

      <div class="not_allow" @click="checkGame">
        <img src="../../../assets/svg/monthCard/alert-circle.svg" alt="" />
        <p>查看赠送余额不适用游戏名单</p>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="&#231;&#174;&#173;&#229;&#164;&#180;-16">
            <path
              id="chevron-right"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.84474 9.34442L4.15531 8.65499L6.81059 5.99971L4.15531 3.34442L4.84474 2.65499L8.18945 5.99971L4.84474 9.34442Z"
              fill="#999999"
            />
          </g>
        </svg>
      </div>

      <div class="yhqDetail lbDetail">
        <div class="yhq_top">
          <img src="../../../assets/yz/monthIcon/yz_newMonth_lb.png" alt="" />
          <div>
            <p>月卡专属礼包</p>
            <span>部分游戏可领取月卡专属礼包</span>
          </div>
        </div>
      </div>

      <div class="yhqDetail rzDetail">
        <div class="yhq_top">
          <div>
            <p>月卡身份专属认证</p>
            <span>社交等功能头像右侧显示认证图标</span>
          </div>
          <img src="../../../assets/yz/monthIcon/yz_newMonth_rz.png" alt="" />
        </div>
      </div>
    </div>

    <!-- vip弹窗 -->
    <van-popup
      v-model:show="state.show"
      round
      position="bottom"
      :style="{ backgroundColor: '#283138' }"
    >
      <div class="popup-box">
        <p class="pop-title">购买月卡</p>
        <h3><span>¥</span>{{ state.amount }}</h3>
        <ul>
          <li @click="goSell('zfb')">
            <div>
              <img src="../../../assets/personal/ico_zfbzf.png" /> 支付宝支付
            </div>
          </li>
          <li @click="goSell('wx')">
            <div>
              <img src="../../../assets/personal/ico_wxzf.png" /> 微信支付
            </div>
          </li>
        </ul>
      </div>
    </van-popup>

    <!-- 不可用游戏弹窗 -->
    <van-popup
      v-model:show="state.showGame"
      round
      position="bottom"
      class="geme_notAllow"
      :style="{ height: '70%', backgroundColor: '#283138' }"
      closeable
      @close="closePop"
      @open="openPop"
    >
      <h3>赠送余额不可用游戏</h3>
      <div class="search">
        <input
          type="text"
          v-model="state.gamename"
          placeholder="输入游戏名查询"
        />
        <span @click="gameSearch">搜索</span>
      </div>
      <h4>以下游戏暂不可用</h4>
      <p>赠送余额适用于大部分游戏，仅以下游戏暂不支持</p>
      <div class="gameList">
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-grid :gutter="8" :border="false" :center="false">
            <van-grid-item
              v-for="(item, i) in state.gameList"
              :key="i + '-list'"
            >
              <template #default>
                <img :src="item.pic1" alt="" />
                <h4>{{ item.gamename }}</h4>
                <p v-show="item.name_sub">{{ item.name_sub }}</p>
              </template>
            </van-grid-item>
          </van-grid>
        </van-list>
      </div>
    </van-popup>

    <van-overlay :show="state.overlayFlag" duration="0" class="load-overlay">
      <van-loading color="#00D9C3" size="24px" vertical>
        加载中...
      </van-loading>
    </van-overlay>
  </div>
</template>
<script setup>
import { useRouter, onBeforeRouteUpdate } from "vue-router";

import { useStore } from "vuex";

import { reactive, onDeactivated, onActivated } from "vue";

import {
  monthCardInfo,
  monthCardGetCoupon,
  McStatus,
  monthCardGetGivemoney,
  monthCardNoGame,
} from "@/api/yzuser";

import { newWxpayMonth, newAlipayMonth } from "@/api/yzpay";

import { Toast } from "vant";

import { detect, randomString } from "@/utils/device";

import { getQueryString } from "@/utils/location";
import { setToken, removeToken } from "@/utils/auth";

import { encrypt, decrypt } from "@/utils/rsa";

const router = useRouter();
const store = useStore();

const state = reactive({
  userName: "",
  userAvatar: "",
  activeNum: "",
  monthCardInfo: [],
  amount: 30,
  // 支付弹窗
  show: false,
  time: "",
  monthcardFlag: false,
  cardValue: "",
  day: 0,
  number: 0,
  pay: "",

  // 最高可得奖励
  maxAward: 230,
  maxPercent: "460",
  maxGiveMoney: 150,
  maxGivecoupon: 180,
  coupon_money: 50,

  // 福利

  // 选中的福利
  awardNum: "coupon",
  // 不可用游戏弹窗
  showGame: false,
  dayNum: 30,

  loading: false,
  finished: false,
  gameList: [],
  gamename: "",
  overlayFlag: true,
});

onActivated(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }

  // 清除cookie

  state.userAvatar = getQueryString("avatar");
  state.userName = getQueryString("name");
  state.userId = getQueryString("username");
  state.uid = getQueryString("uid");
  state.activeNum = 1;
  state.maxAward = 230;
  state.maxPercent = "460";
  state.gamename = "";
  state.maxGiveMoney = 150;
  state.maxGivecoupon = 180;
  state.dayNum = 30;

  // 获取月卡信息
  getMonthCardInfo();

  // 获取用户月卡状态
  getUserMonth();
});

// 获取用户月卡状态
const getUserMonth = () => {
  McStatus({ username: state.userId }).then((response) => {
    if (response.data.monthcard == 1) {
      state.time = response.data.endtime.slice(0, 10);
      state.monthcardFlag = true;
      Local.get("awardNum") && selectAward(Local.get("awardNum"));
    } else {
      state.monthcardFlag = false;
    }
  });
};

onDeactivated(() => {});

// 跳转至月卡开通记录页
const goOpenRecord = () => {
  router.push({
    path: "/newopen_record",
    query: {
      uid: state.uid,
    },
  });
};
// 跳转至月卡领取记录页
const goGetRecord = () => {
  let title = "领取记录";
  window.document.location = "getrecord://" + title;
};

// onBeforeRouteUpdate((to, from, next) => {
//   console.log("页面更新------------------------------");
//   next(window.scrollTo(0, 0), getMonthCardInfo(), getUserMonth());
// });

// 选择套餐
const selectCard = (data) => {
  state.activeNum = data.id;
  state.amount = data.amount;
  state.cardValue = data.jiazhi;
  state.day = data.name;
  state.number = data.buyday;
  state.money = data.money;
  state.maxAward = data.jiazhi;
  state.maxPercent = Math.round((data.jiazhi / data.amount) * 100);
  state.dayNum = data.buyday;
  state.maxGivecoupon = data.buyday * 6;
  state.maxGiveMoney = data.buyday * 5;
  state.coupon_money = data.coupon_money;
};

// 选择奖励
import { Local } from "@/utils/storage";
const selectAward = (data) => {
  state.awardNum = data;
  Local.set("awardNum", data);
};

// 领取优惠券

// 领取优惠券
let fetchFlag = false;
const getAward = async () => {
  if (fetchFlag) return;
  fetchFlag = true;
  if (state.awardNum == "coupon") {
    const res = await monthCardGetCoupon({ uid: state.uid, imei: "" });
    Toast(res.data.msg);
  } else {
    const res = await monthCardGetGivemoney({ uid: state.uid, imei: "" });
    Toast(res.data.msg);
  }
  fetchFlag = false;
};

// 开通月卡
const openCard = () => {
  state.show = true;
};

// 获取月卡信息
const getMonthCardInfo = async () => {
  const res = await monthCardInfo({ uid: state.uid });
  if (res.data.code == "1") {
    state.monthCardInfo = res.data.data;
    state.cardValue = res.data.data[0].jiazhi;

    state.day = res.data.data[0].name;
    state.number = res.data.data[0].buyday;
    state.amount = res.data.data[0].amount;
    state.money = res.data.data[0].money;
    console.log("月卡信息------------------", state.monthCardInfo);
    selectCard(state.monthCardInfo[0]);
  } else {
    Toast(res.data.msg);
  }
  state.overlayFlag = false;
};

// 购买会员
const goSell = async (zf) => {
  state.pay = zf;
  let type = detect();
  let paydata = {
    z: "",
    b: state.amount,
    c: state.userId,
    os: type,
    pr: state.number,
    money: state.money,
    number: state.number,
    x: "zksq_yueka_" + zf + "_" + randomString(5) + Date.now(),
    cash: 0,
  };
  console.log("支付参数", paydata);
  if (zf == "zfb") {
    paydata.z = "zfb";
    newAlipayMonth(paydata).then((response) => {
      if (response.data.code == 1) {
        const div = document.createElement('div');
                div.innerHTML = response.data.data;
                document.body.appendChild(div);
                document.forms[0].submit();
        // window.document.location =
        //   "payalimonthcard://" + encodeURIComponent(JSON.stringify(paydata));
      } else {
        Toast(response.data.msg);
      }
    });
  } else {
    paydata.z = "wx";
    newWxpayMonth(paydata).then((response) => {
      if (response.data.code == 1) {
        window.webkit.messageHandlers.JsBridge.postMessage([
          "openUrl",
          "https://zksqh5.5535.cn/#/weixinpay?url=" + encodeURIComponent(response.data.data)
        ]);
        // window.JsBridge.openUrl("https://zksqh5.5535.cn/#/weixinpay?url=" + encodeURIComponent(response.data.data));
        // window.document.location = "openurl://" + "https://zksqh5.5535.cn/#/weixinpay?url=" + encodeURIComponent(response.data.data)
        // document.location.href = response.data.data;
      } else {
        Toast(response.data.msg);
      }
    });
  }
  state.show = false;
};

// 查看不可用游戏
const checkGame = async () => {
  state.showGame = true;
};
// 打开抽奖记录
const openPop = async () => {
  pagecode = 1;
  state.gameList = [];
  state.finished = false;
  state.loading = true;
  await getGameList();
};
const closePop = async () => {
  pagecode = 1;
  state.gameList = [];
  state.finished = false;
  state.loading = true;
};

const gameSearch = () => {
  state.gameList = [];
  pagecode = 1;
  state.finished = false;
  onLoad();
};

const onLoad = async () => {
  pagecode++;
  await getGameList();
};
var pagecode = 0;
let fetchFlag2 = false;
const getGameList = async () => {
  if (fetchFlag2) return;
  fetchFlag2 = true;

  try {
    let res = await monthCardNoGame({
      pagecode: pagecode,
      gamename: state.gamename,
    });
    if (res.data.code == 1) {
      state.gameList = state.gameList.concat(res.data.data.lists);
      if (pagecode >= res.data.data.total_page) {
        state.finished = true;
      }
    } else {
      state.finished = true;
      state.loading = false;
    }
    state.loading = false;
  } catch (error) {
    // state.finished = true;
  }
  fetchFlag2 = false;
};
</script>

<style src="../../../styles/van-sticky-nav.css"></style>
<style scoped>
:deep(.van-overlay) {
  background-color: #0000003c;
}
.van-nav-bar {
  background: rgba(255, 255, 255, 0);
  z-index: 9;
}

.right-nr {
  color: #333;
  font-size: 24px;
}
.allContent {
  width: 100vw;
  min-height: 100vh;
  background-color: #161b1f;
  /* padding-bottom: 100px; */
  /* padding-top: calc(100px + constant(safe-area-inset-top)); */
  /* 适配安全区域 iOS < 11.2 */
  /* padding-top: calc(100px + env(safe-area-inset-top)); */
  /* 适配安全区域 iOS >= 11.2 */
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_bg.png);
  background-size: 100% 442px;
  background-repeat: no-repeat;
  background-position-y: -95px;
  padding-bottom: 200px;
}

.userInfo {
  width: 100%;
  height: 208px;
  display: flex;
  align-items: center;
  padding: 0 32px;
}

.userInfo img {
  width: 104px;
  height: 104px;
  margin-right: 24px;
  border-radius: 50%;
}
.userInfo .userText {
  flex: 1;
}
.userInfo .userText .userName {
  color: #fff;
  font-size: 24px;
}

.userInfo .userText .userTime {
  color: #999999;
  font-size: 16px;
  margin-top: 12px;
}

.userInfo .userHistoty {
  margin-left: 80px;
  width: 118px;
  height: 43px;
  background: linear-gradient(90deg, #facf7a 0%, #f3b644 100%);
  border-radius: 100px 100px 100px 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #744b00;
}

/* 福利信息 */
.award_info {
  width: 686px;
  height: 406px;
  background-color: #283138;
  border-radius: 30px;
  margin: 0 32px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 102px;
  font-size: 28px;
}
.award_info h3 {
  color: #ff974f;
}
.award_info ul {
  margin: 20px 0 32px 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.award_info ul li {
  width: 152px;
  height: 152px;
  background-color: #fffaf0;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.award_info ul li.active {
  border: 6px solid #f1ae33;
  position: relative;
}
.award_info ul li.active::before {
  content: "";
  width: 40px;
  height: 40px;
  position: absolute;
  right: -4px;
  bottom: -4px;
  background-image: url(../../../assets/yz/monthIcon/award_selected.png);
  background-size: 100% 100%;
}
.award_info ul li div {
  width: 106px;
  height: 82px;
  margin: 16px 0 18px 0;
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_couponBg.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
}

.award_info ul li div > p:nth-of-type(1) {
  color: #fe5064;
  margin-bottom: 8px;
}
.award_info ul li div > p > span {
  font-size: 34px;
  font-weight: 800;
}
.award_info ul li:nth-of-type(2) div {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_givemoneyBg.png);
}
.award_info ul li:nth-of-type(2) p:nth-of-type(1) {
  margin-left: 40px;
  padding-top: 10px;
  margin-bottom: 8px;
}
.award_info ul li:nth-of-type(2) p:nth-of-type(2) {
  font-size: 13px;
  color: #af6e21;
}
.award_info > p {
  width: 482px;
  height: 74px;
  background: linear-gradient(270deg, #face78 0%, #f3b643 100%);
  border-radius: 100px;
  line-height: 84px;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: #744b00;
}

/* 会员卡 */
.cardInfo {
  padding: 0 32px;
  background-color: #161b1f;
}

.cardInfo .buyCard {
  width: 100%;
  height: 728px;
  background-color: #283138;
  border-radius: 30px;
  padding: 40px 24px;
}

.buyCard .cardRule {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #fff;
  font-weight: 800;
  background-color: #3f4951;
  padding: 14px 20px;
  margin-bottom: 50px;
  border-radius: 10px;
}

.buyCard .cardRule img {
  width: 24px;
  height: 24px;
}

.buyCard .cardRule img:nth-of-type(1) {
  margin-right: 12px;
}

.buyCard .cardRule span {
  margin-right: 210px;
  flex: 1;
}

.buyCard .cardDetails {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 28px;
}

.buyCard .cardDetails li {
  width: 172px;
  height: 172px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: #fffef8;
  border: 2px solid #fce9bc;
  border-radius: 20px;
  padding: 32px 0;
  position: relative;
}

.buyCard .cardDetails li.active {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_select.png);
  background-repeat: no-repeat;
  background-size: cover;
  border: none;
  position: relative;
}
.buyCard .cardDetails li.active::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 16px;
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_select_icon.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  bottom: -16px;
  left: calc(50% - 18px);
}

.buyCard .cardDetails li p:nth-of-type(1) {
  color: #333;
  font-size: 20px;
  font-weight: 800;
  /* margin-top: 32px; */
  margin-bottom: 8px;
}
.buyCard .cardDetails li p:nth-of-type(2) {
  color: #707070;
  font-size: 16px;
  text-decoration: line-through;
}

.buyCard .cardDetails li p:nth-last-of-type(1) {
  color: #333;
  font-size: 52px;
  font-weight: 800;
  margin-bottom: 8px;
}
.buyCard .cardDetails li p span {
  font-size: 16px;
}
.buyCard .cardDetails li div {
  color: #666666;
  font-size: 16px;
  font-weight: 500;
  position: absolute;
  top: -18px;
  left: 12px;
  /* width: 96px; */
  padding: 0 8px;
  height: 32px;
  border-radius: 6px;
  background: linear-gradient(99deg, #ff6666 0%, #ffac5f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* 优惠信息*------------- */
.buyCard .yuqInfo {
  width: 638px;
  height: 345px;
  background: #3f4951;
  border-radius: 30px;
  font-size: 20px;
  padding: 24px;
  color: #fff;
}
.buyCard .yuqInfo h3 {
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  margin-bottom: 16px;
  position: relative;
}
.buyCard .yuqInfo h3::before {
  content: "";
  position: absolute;
  width: 70px;
  height: 12px;
  background: linear-gradient(
    90deg,
    rgba(255, 113, 113, 0.3) 0%,
    rgba(255, 71, 71, 0) 100%
  );
  right: 124px;
  bottom: 2px;
}
.buyCard .yuqInfo h3 span {
  color: #ff6666;
}
.buyCard .yuqInfo .yuqInfo_content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.buyCard .yuqInfo .yuqInfo_left {
  width: 180px;
  height: 178px;
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 16px;
}
.buyCard .yuqInfo .yuqInfo_left > div {
  width: 108px;
  height: 84px;
  margin: 12px 0 16px 0;
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_couponBg.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
}
.buyCard .yuqInfo .yuqInfo_left > div > p:nth-of-type(1) {
  color: #fe5064;
  margin-bottom: 18px;
}
.buyCard .yuqInfo .yuqInfo_left > div > p > span {
  font-size: 34px;
  font-weight: 800;
}
.buyCard .yuqInfo .yuqInfo_left > p {
  font-size: 12px;
  color: #af6e21;
}
.buyCard .yuqInfo .yuqInfo_right {
  width: 362px;
  height: 180px;
  background: #fff;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 12px;
  color: #333;
}
.buyCard .yuqInfo .yuqInfo_right h4 span {
  color: #ff7700;
}
.buyCard .yuqInfo .yuqInfo_right > div {
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  padding: 0 32px;
}
.buyCard .yuqInfo .yuqInfo_right > div > p {
  width: 28px;
  height: 28px;
  background-color: #ff6666;
  border-radius: 100%;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  margin-top: 34px;
}
.buyCard .yuqInfo .yuqInfo_right .right_coupon div,
.buyCard .yuqInfo .yuqInfo_right .right_givemoney div {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_couponBg.png);
  background-size: 100% 100%;
  width: 108px;
  height: 84px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}
.buyCard .yuqInfo .yuqInfo_right .right_givemoney div {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_givemoneyBg.png);
  color: #744b00;
}
.buyCard .yuqInfo .yuqInfo_right .right_coupon div p:nth-of-type(1),
.buyCard .yuqInfo .yuqInfo_right .right_givemoney div p:nth-of-type(1) {
  color: #fe5064;
  margin-bottom: 18px;
}
.buyCard .yuqInfo .yuqInfo_right .right_givemoney div p:nth-of-type(1) {
  margin-left: 40px;
  padding-top: 10px;
  margin-bottom: 8px;
}

.buyCard .yuqInfo .yuqInfo_right .right_coupon div p:nth-of-type(1) span,
.buyCard .yuqInfo .yuqInfo_right .right_givemoney div p:nth-of-type(1) span {
  font-size: 34px;
  font-weight: 800;
}
.buyCard .yuqInfo .yuqInfo_right .right_coupon > p,
.buyCard .yuqInfo .yuqInfo_right .right_givemoney > p {
  color: #af6e21;
  font-size: 16px;
  text-align: center;
}

.buyCard .yuqInfo li {
  font-weight: 400;
  font-size: 20px;
}
.buyCard .yuqInfo li span {
  color: #ff6666;
}
/* 购买按钮 */
.buyCard .goBuyCard {
  width: 638px;
  height: 96px;
  border: none;
  background: linear-gradient(90deg, #facf7b 0%, #f3b542 100%), #00d9c5;
  border-radius: 20px;
  margin-top: 32px;
  font-weight: 600;
  font-size: 28px;
  color: #5c3114;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 20px;
}

/* 优惠券不可用游戏 */
.not_allow {
  width: 686px;
  height: 72px;
  background-color: #283138;
  margin-top: 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-size: 16px;
  color: #fff;
}
.not_allow p {
  flex: 1;
  margin-left: 12px;
}

.yhqDetail {
  background-color: #283138;
  border-radius: 30px;
  margin: 26px 0 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
}
.yhqDetail .yhq_top {
  display: flex;
  justify-content: space-around;
  margin-bottom: 32px;
}
.yhqDetail .yhq_top img {
  width: 132px;
  height: 132px;
}

.yhqDetail .yhq_top > div {
  width: 486px;
}
.yhqDetail .yhq_top > div p {
  font-size: 32px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px;
}
.yhqDetail .yhq_top > div span {
  color: #999999;
  font-size: 24px;
  display: inline-block;
  width: 428px;
}
.lbDetail .yhq_top > div span {
  color: #666666;
  font-size: 24px;
  display: inline-block;
  width: 428px;
  display: flex;
  justify-content: flex-end;
}
.lbDetail {
  padding: 28px 0;
}
.lbDetail .yhq_top {
  margin-bottom: 28px;
}
.lbDetail .yhq_top > div {
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
.rzDetail {
  padding: 28px 0;
}
.rzDetail .yhq_top {
  margin-bottom: 28px;
}
.rzDetail .yhq_top > div {
  margin-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.popup-box {
  width: 100%;
  height: 658px;
  padding: 30px;
}

.popup-box .pop-title {
  font-size: 32px;
  color: #fff;
  font-weight: 500;
  text-align: center;
}

.popup-box h3 {
  font-size: 64px;
  color: #fff;
  text-align: center;
  margin: 8px 0;
}

.popup-box h3 span {
  font-size: 32px;
}

.popup-box ul {
  margin-top: 30px;
}

.popup-box ul li {
  width: 686px;
  height: 112px;
  border-radius: 20px;
  background-color: #3f4951;
  line-height: 112px;
  font-size: 26px;
  margin-bottom: 20px;
  padding-left: 24px;
}

.popup-box ul li div {
  color: #fff;
  font-size: 28px;
  font-weight: 500;
}

.popup-box ul li img {
  width: 50px;
  vertical-align: middle;
  margin-right: 20px;
}
.emptyMoney {
  width: 100%;
  height: 20px;
  margin-top: 30px;
}

/* 不可用游戏弹窗 */
:deep(.geme_notAllow) {
  padding: 32px;
  color: #fff;
}
:deep(.geme_notAllow) h3 {
  text-align: center;
  margin-bottom: 32px;
}
:deep(.geme_notAllow) .search input {
  border: none;
  width: 590px;
  height: 88px;
  background: #f7f7f7;
  border-radius: 198px;
  padding-left: 32px;
  margin-right: 32px;
  color: #333;
}
:deep(.geme_notAllow) .search span {
  font-size: 32px;
  color: #fff;
}
:deep(.geme_notAllow) > h4 {
  margin: 32px 0 12px 0;
  font-size: 32px;
}
:deep(.geme_notAllow) > p {
  font-size: 20px;
  color: #999;
  margin-bottom: 28px;
}
:deep(.geme_notAllow) .gameList {
  height: 36vh;
  overflow: auto;
}
:deep(.geme_notAllow) .gameList .van-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
:deep(.geme_notAllow) .gameList .van-cell {
  width: 142px;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 20px;
}
:deep(.geme_notAllow) .gameList .van-cell__value {
  display: flex;
  flex-direction: column;
}

:deep(.van-grid-item__content) {
  width: 148px;
  white-space: nowrap;
  align-items: center;
  padding-bottom: 24px;
  background-color: #3f4951;
}
:deep(.geme_notAllow) .gameList img {
  width: 120px;
  height: 120px;
  border-radius: 20px;
}
:deep(.geme_notAllow) .gameList h4 {
  font-size: 28px;
  margin: 12px 0 4px 0;
  width: 142px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:deep(.geme_notAllow) .gameList p {
  max-width: 142px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 8px;
  font-size: 20px;
  color: #666666;
  background: #f3f4f8;
  border-radius: 6px;
}
:deep(.game_notAllow) .van-list__finished-text {
  position: absolute;
}

/* 加载框 */
.allContent :deep(.load-overlay) {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
